import { Grid } from "@mui/material";
import { Input, InputSwitch } from "controls";
import React from "react";

const AddressBook = ({ values, errors, handleInpChg, handleInpCheck }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} className="!mt-[15px]">
        <span className="border-left uppercase font-semibold text-gray-500 pl-[8px]">
          Physical Address
        </span>
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Address Line 1"
          name="address1"
          value={values.address1}
          error={errors.address1}
          inputProps={{ maxLength: 300 }}
          multiline
          rows={2}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Address Line 2"
          name="address2"
          value={values.address2}
          error={errors.address2}
          inputProps={{ maxLength: 300 }}
          multiline
          rows={2}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Input
          label="City"
          name="city"
          value={values.city}
          error={errors.city}
          inputProps={{ maxLength: 150 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Input
          label="State"
          name="state"
          value={values.state}
          error={errors.state}
          inputProps={{ maxLength: 150 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Input
          label="ZIP"
          name="zip"
          value={values.zip}
          error={errors.zip}
          inputProps={{ maxLength: 50 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12}>
        <InputSwitch
          label="Use different address for postal address"
          fontSize="16px"
          name="isPostalAddress"
          checked={values.isPostalAddress}
          onChange={handleInpCheck}
        />
      </Grid>

      {values.isPostalAddress && (
        <>
          <Grid item xs={12} className="!mt-[15px]">
            <span className="border-left uppercase font-semibold text-gray-500 pl-[8px]">
              Postal Address
            </span>
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              label="Address Line 1"
              name="pAddress1"
              value={values.pAddress1}
              error={errors.pAddress1}
              inputProps={{ maxLength: 300 }}
              multiline
              rows={2}
              onChange={handleInpChg}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              label="Address Line 2"
              name="pAddress2"
              value={values.pAddress2}
              error={errors.pAddress2}
              inputProps={{ maxLength: 300 }}
              multiline
              rows={2}
              onChange={handleInpChg}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Input
              label="City"
              name="pCity"
              value={values.pCity}
              error={errors.pCity}
              inputProps={{ maxLength: 150 }}
              onChange={handleInpChg}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Input
              label="State"
              name="pState"
              value={values.pState}
              error={errors.pState}
              inputProps={{ maxLength: 150 }}
              onChange={handleInpChg}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Input
              label="ZIP"
              name="pZip"
              value={values.pZip}
              error={errors.pZip}
              inputProps={{ maxLength: 50 }}
              onChange={handleInpChg}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AddressBook;
